<template>
  <div>
      <!--Header Components-->
      <base-header class="mt-4 pb-6" type=""/>
      <b-container fluid class="mt--6">
        <div>
          <loading :active="loadingCounter > 0" color= '#007bff' :width= '128' :height= '128' loader='dots' :can-cancel="true" is-full-page/>
        </div>
        <b-row>
          <b-col lg="12">
            <div class="card-wrapper">
              <card>
                <div slot="header" class="mb-0">
                  <b-row>
                    <b-col cols="8">
                        <h3>{{language_terms['PAYMENT_VOUCHERS']}}</h3>
                    </b-col>
                    <b-col cols="4">
                       <base-button type="success" @click="addNew" class="float-right">
                          <i class="fa fa-plus"></i>
                          <!-- {{language_terms['NEW']}} -->
                          <!-- {{type == 'SALES' ? language_terms['SALES_RECEIPTS'] : language_terms['PURCHASE_RECEIPTS']}} -->
                        </base-button>
                    </b-col>
                  </b-row>
                </div>
                <b-row>
                  <b-col md="4" >
                    <base-input :label="language_terms['QUICK_FILTER']" v-model="filter.keyword" v-on:keyup.enter="onClickSearch">
                    </base-input>
                  </b-col>
                  <b-col md="2" >
                    <base-input :label="language_terms['DATE_FROM']">
                      <flat-picker slot-scope="{focus, blur}"
                                  @on-open="focus"
                                  @on-close="blur"
                                  style="background-color: white;"
                                  class="form-control datepicker"
                                  v-model="filter.date_from">
                      </flat-picker>
                    </base-input>
                  </b-col>
                  <b-col md="2">
                    <base-input :label="language_terms['DATE_TO']">
                      <flat-picker slot-scope="{focus, blur}"
                                  @on-open="focus"
                                  @on-close="blur"
                                  style="background-color: white;"
                                  class="form-control datepicker"
                                  v-model="filter.date_to">
                      </flat-picker>
                    </base-input>
                  </b-col>

                  <b-col md="3">
                    <base-input :label="language_terms['DOCUMENT_TYPE']">
                      <el-select v-model="filter.doc_type" filterable>
                          <el-option v-for="doctype in doc_type_options"
                                    :key="doctype.value"
                                    :label="doctype.label"
                                    :value="doctype.value">
                          </el-option>
                        </el-select>
                    </base-input>
                  </b-col>

                  <b-col cols="1" class="mt-4">
                    <base-button type="primary" @click="onClickSearch" class="mt-2">
                      <i class="fa fa-search"></i>
                    </base-button>
                  </b-col>
                </b-row>
              </card>
              <!-- Search Results -->
              <PaginatedTables :myColumns="tableColumns" :tableData="receipts" :cardTitle="language_terms['SEARCH_RESULTS']" v-if="receipts.length > 0"/>
            </div>
          </b-col>
        </b-row>
        <!-- <a href="javascript:void(0)" class="float" @click="addNew">
          <i class="fa fa-plus my-float"></i>
        </a> -->
      </b-container>
  </div>
</template>
<script>
import axios from "axios";
import { apiRoutes } from "@/apiRoutes";
import { authHeader } from "@/global";

import { Select, Option } from 'element-ui'
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';  
import { mapState } from "vuex";
import PaginatedTables from '@/views/Tables/PaginatedTables'

export default {
  components:{
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    flatPicker,
    PaginatedTables
  },
      computed:{
      ...mapState({
        language_terms: state => state.languages.language_terms,
        selected_lang: state => state.languages.selected_langauge,
      }),
    },
  watch:{
     language_terms: {
          handler(val){
              this.updateTableLang()
          }
        },
      receipts: {
      // This will let Vue know to look inside the array
      deep: true,
      handler(){
        console.log("A")
        this.items = this.receipts
      }
    }
  },
  async mounted()
  {
    this.loadingCounter++
    this.updateTableLang()
    this.loadingCounter--
  },
  data(){
    return{
      doc_type_options:[
        {
          label:"PAYMENT VOUCHER",
          value:'PV'
        },
        {
          label:"DEBIT NOTE",
          value:"DN"
        },
        {
          label:"OFFSET",
          value:"OFFSET"
        },
        {
          label:"REFUND",
          value:"REFUND"
        },
      ],
      receipts:[],
      loadingCounter:0,
      filter:{
        doc_type:'PV',
        keyword:"",
        date_from:null,
        date_to:null,
        type:'PURCHASE',
        status:'ALL'
      },
      tableColumns: [
            {
              prop: 'code',
              label: 'Document#',
              minWidth: 80,
              sortable: true,
              key:'CODE'

            },
            {
              prop: 'contact_name',
              label: 'Customer',
              minWidth: 200,
              sortable: true,
              key:'CUSTOMER'

            },
            {
              prop: 'date',
              label: 'Date',
              minWidth: 80,
              sortable: true,
              key:'DATE'

            },
            {
              prop: 'mode',
              label: 'Payment Mode',
              minWidth: 80,
              sortable: true,
              key:'PAYMENT_MODE'

            },
            {
              prop: 'reference',
              label: 'Reference',
              minWidth: 150,
              sortable: true,
              key:'REFERENCE'
            },
            {
              prop: 'amount',
              label: 'Amount',
              minWidth: 120,
              sortable: true,
              key:'AMOUNT'
            },
            // {
            //   prop: 'is_void',
            //   label: 'Void',
            //   minWidth: 140,
            //   sortable: true,
            //   key:'IS_VOID'

            // },
        ],

    }
  },

  methods:{
     updateTableLang(){
      for(let i=0; i < this.tableColumns.length;i++)
      {
         let key = this.tableColumns[i].key
         this.tableColumns[i].label = this.language_terms[key]
      }
    },
    async onClickSearch(){
      this.loadingCounter++

      let payload = this.filter
      axios.post(apiRoutes['RECEIPTS_QUICK_SEARCH'], payload, authHeader())
      .then(response => 
      {
          if(response.data.code == 1)
          {
            this.receipts = response.data.data
          } 
          else 
          {
            this.receipts = []
          }
        })
        .catch(error => {
          if (error.response) {
           Vue.notify({group: 'notify', type: 'error', text: error.response.data.msg, max: 5, duration: 5000, speed: 300})
          }
      });

      this.loadingCounter--
    },
    clickOnReset(){
      this.filter = {
          keyword:"",
          date_from:null,
          date_to:null,
          status:'ALL',
          type:'PURCHASE',
      }
    },
    async addNew(){
      let url = '/finance/purchase-receipt/_new'
      this.$router.push(url)
    }
  }
}
</script>
